import { render, staticRenderFns } from "./NewFeatureBadge.vue?vue&type=template&id=1f2a60fc"
import script from "./NewFeatureBadge.vue?vue&type=script&lang=js"
export * from "./NewFeatureBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f2a60fc')) {
      api.createRecord('1f2a60fc', component.options)
    } else {
      api.reload('1f2a60fc', component.options)
    }
    module.hot.accept("./NewFeatureBadge.vue?vue&type=template&id=1f2a60fc", function () {
      api.rerender('1f2a60fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/NewFeatureBadge.vue"
export default component.exports